import { render, staticRenderFns } from "./RegistroTerminal.vue?vue&type=template&id=13c575a4"
import script from "./RegistroTerminal.vue?vue&type=script&lang=js"
export * from "./RegistroTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports